export default __webpack_public_path__ + "static/media/Miro.408722ea.svg";